module.exports = __webpack_public_path__ + "media/images/new_home/product-1-94212c9ace16906caecba2377d074df8.png";